// sessionStorage keys used to tame the single-IdP auto-redirect.
//
// AutoSsoSuppressKey — set by an explicit logout so the user lands on the login
// page instead of being silently re-authenticated by a still-live upstream
// (Keycloak/OneLogin) session. NOT consumed on read; cleared only on an
// explicit sign-in or once authenticated (so React StrictMode's double-invoked
// effect in dev can't re-trigger the redirect).
export const AutoSsoSuppressKey = 'suppressAutoSso';

// AUTO_SSO_GUARD_KEY / window — one auto-redirect attempt per window, then fall
// through to the manual page. Cheap insurance against any rapid re-mount loop.
export const AUTO_SSO_GUARD_KEY = 'autoSsoAt';
export const AUTO_SSO_GUARD_WINDOW_MS = 15_000;

// localStorage key for a user's (Keycloak sub) security params, stored as
// { [agentId]: params }. Written by AgentConfigContext, removed by AuthContext.signOut.
export const securityParamsKey = (userId) => `securityParamsByAgent:${userId}`;
